<template lang="pug">
div
  section.full__video
    .intro__content.intro__content--mobile
      h1.hostingEmbed__title Embed and Share Cinemagraphs
      h2 Share your visual stories on a global stage
      .btn__group.btn__group--splash
        get-plan(classes='btn btn--white btn__splash')

    .fluid__video
      .intro__content.intro__content--desktop
        h1.hostingEmbed__title Embed and Share Cinemagraphs
        h2 Share your visual stories on a global stage
        .btn__group
          get-plan(classes='btn btn--white')
      iframe.lazy(data-src='https://media.flixel.com/cinemagraph/jy9hh46vole2fu9znowb?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/lensofadventure/') Lensofadventure

  section.hosting__section
    .hosting__section--container
      .hosting__section--content
        .hosting__item--title
          h2 Cinemagraphs everywhere

        .hosting__item--desc
          p Use the unique Flixel embed code to easily display your cinemagraphs that will auto-play and auto-loop on websites and blogs.

      .hosting__item--cinemagraph
        .fluid__video
          iframe(data-src='https://media.flixel.com/cinemagraph/gaeo6szkj6bg0pvwc1xr?hd=true' allow='autoplay')

  section.hosting__section
    .hosting__section--container.hosting__section--reverse
      .hosting__section--content
        .hosting__item--title
          h2 Share with the world

        .hosting__item--desc
          p Your work becomes an infinite experience that will inspire audiences around the world on Flixel.com. Create a custom Flixel gallery filled with your beautiful visual stories in stunning HD and use it as a portfolio to grow your business.

      .hosting__item--cinemagraph
        .fluid__video
          iframe(data-src='https://media.flixel.com/cinemagraph/7kcb88fjch55b1922rnz?hd=true' allow='autoplay')

  section.hosting__section
    .hosting__section--container.hosting__section--benefits
      .hosting__item
        .hosting__item--img
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/icons/hosting-storage@2x.png 2x, https://cdn.flixel.com/static/static-web/icons/hosting-storage.png')
        .hosting__item--title
          h2 Unlimited Cinemagraph Uploads for your Flixel Gallery
        .hosting__item--desc
          p Create and upload your work without worrying about the space.
      .hosting__item
        .hosting__item--img
          img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/icons/hosting-views@2x.png 2x, https://cdn.flixel.com/static/static-web/icons/hosting-views.png')
        .hosting__item--title
          h2 100,000 web embed views per month
        .hosting__item--desc
          p Capture and hold attention on blogs and websites with over one million free embed views annually.

  section.flixelPlan__section
    .flixelPlan__container
      h1 Choose a plan that’s right for you
      p Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform.
      .btn__group
        get-plan(classes='btn btn--white')
</template>

<script>
import getPlan from 'components/getPlan.vue';
import productmixin from './productmixin.vue';

export default {
  name: 'hosting',
  metaInfo: {
    title: 'Sharing Cinemagraphs on Web Made Easy | Flixel',
    meta: [
      {
        'property': 'image',
        'content': 'https://cdn.flixel.com/static/static-web/Hosting.png',
      },
      {
        'property': 'description',
        'content': 'Upload and easily share cinemagraphs on blogs and websites using the world’s best cinemagraph hosting platform, Flixel Cloud.',
      },
    ],
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
  data() {
    return {
      modalShow: false,
      ytVideo: '',
      modalProduct: false,
    };
  },
  mixins: [productmixin],
  components: {
    'getPlan': getPlan,
  },
};
</script>


// WEBPACK FOOTER //
// src/views/products/hosting.vue